var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header"),
      _c(
        "b-modal",
        {
          attrs: { scroll: "clip" },
          model: {
            value: _vm.isCardModalActive,
            callback: function ($$v) {
              _vm.isCardModalActive = $$v
            },
            expression: "isCardModalActive",
          },
        },
        [
          _c("div", { staticClass: "modal-card-body has-text-centered" }, [
            _c("h3", { staticClass: "modal-title" }, [
              _vm._v("Verifica que tus datos sean correctos"),
            ]),
            _c("div", { staticClass: "resume-container" }, [
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [
                  _vm._v("Cliente: "),
                ]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formData[0].fields[0].value +
                        " " +
                        _vm.formData[0].fields[1].value
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [_vm._v("RUT: ")]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[0].fields[2].value)),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [_vm._v("Correo: ")]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[1].fields[6].value)),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [
                  _vm._v("Teléfono: "),
                ]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[1].fields[5].value)),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [_vm._v("Región: ")]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[1].fields[0].value)),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [_vm._v("Comuna: ")]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[1].fields[1].value)),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [
                  _vm._v("Dirección: "),
                ]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formData[1].fields[2].value +
                        " " +
                        _vm.formData[1].fields[3].value
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "resume-line-container" }, [
                _c("h1", { staticClass: "resume-label" }, [
                  _vm._v("N° Block/Dpto/Casa: "),
                ]),
                _c("p", { staticClass: "resume-data" }, [
                  _vm._v(_vm._s(_vm.formData[1].fields[4].value)),
                ]),
              ]),
              _vm.isDebtor
                ? _c("div", [
                    _c("h3", { staticClass: "modal-title" }, [
                      _vm._v("Datos del producto"),
                    ]),
                    _vm.formData[3].fields[0].value
                      ? _c("div", { staticClass: "resume-line-container" }, [
                          _c("h1", { staticClass: "resume-label" }, [
                            _vm._v("Productos Portados: "),
                          ]),
                          _c("p", { staticClass: "resume-data" }, [
                            _vm._v("Todos"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.formData[3].fields.length > 1
                      ? _c("div", { staticClass: "resume-line-container" }, [
                          _c("h1", { staticClass: "resume-label" }, [
                            _vm._v("Productos Portados: "),
                          ]),
                          _c("p", { staticClass: "resume-data" }, [
                            _vm._v(_vm._s(_vm.formData[3].fields[1].value)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.formData[3].fields.length > 1
                      ? _c(
                          "div",
                          _vm._l(
                            _vm.formData[3].fields.slice(3),
                            function (products, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "resume-line-container",
                                },
                                [
                                  _c("h1", { staticClass: "resume-label" }, [
                                    _vm._v(
                                      _vm._s(products.typeOfCredit.value) + ": "
                                    ),
                                  ]),
                                  _c("p", { staticClass: "resume-data" }, [
                                    _vm._v(_vm._s(products.value)),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              !_vm.isDebtor
                ? _c("div", [
                    _c("h3", { staticClass: "modal-title" }, [
                      _vm._v("Datos del nuevo proveedor"),
                    ]),
                    _c("div", { staticClass: "resume-line-container" }, [
                      _c("h1", { staticClass: "resume-label" }, [
                        _vm._v("Banco o institución financiera: "),
                      ]),
                      _c("p", { staticClass: "resume-data" }, [
                        _vm._v(_vm._s(_vm.formData[2].fields[0].value)),
                      ]),
                    ]),
                    _c("div", { staticClass: "resume-line-container" }, [
                      _c("h1", { staticClass: "resume-label" }, [
                        _vm._v("RUT: "),
                      ]),
                      _c("p", { staticClass: "resume-data" }, [
                        _vm._v(_vm._s(_vm.formData[2].fields[1].value)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("section", [
              _c(
                "div",
                { staticClass: "has-text-centered" },
                [
                  _c("h3", [_vm._v("¡Último paso! Finaliza tu solicitud!")]),
                  _c(
                    "b-button",
                    {
                      staticClass: "is-button-primary",
                      attrs: {
                        id: "button-submit-finantial-portability-request",
                        size: "is-medium",
                        rounded: "",
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v(" Enviar ")]
                  ),
                  (!_vm.valid || _vm.isFinancialPortability === null) &&
                  _vm.submitMessage
                    ? _c("p", { staticClass: "help is-danger" }, [
                        _vm._v(
                          " No fue posible validar todos los campos, por favor revisa la información ingresada "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: { "can-cancel": false, "close-on-backdrop": false },
          model: {
            value: _vm.isModalActive,
            callback: function ($$v) {
              _vm.isModalActive = $$v
            },
            expression: "isModalActive",
          },
        },
        [
          _c("div", { staticClass: "modal-card-body has-text-centered" }, [
            _c("h3", { staticClass: "modal-title" }, [
              _vm._v("Tu solicitud de portabilidad fue recibida"),
            ]),
            _c("section", { staticClass: "modal-card-body" }, [
              _c("strong", [
                _c("p", [_vm._v("Mantente atento a tu correo.")]),
                _c("p", [
                  _vm._v(
                    "Te informaremos por ese medio los avances de tu solicitud"
                  ),
                ]),
              ]),
              _c("br"),
              _c("img", {
                attrs: {
                  src: require("@/ui/assets/img/portability-modal.png"),
                },
              }),
            ]),
            _c(
              "a",
              {
                staticClass: "button is-big is-button-primary",
                attrs: { id: "button-finish", href: "https://www.creditu.com" },
              },
              [_vm._v(" Finalizar ")]
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "portability-content transition-slow" }, [
        _c("div", { staticClass: "card-item portability-view" }, [
          _c(
            "div",
            { staticClass: "portability-form" },
            [
              _c("h3", { staticClass: "has-text-centered" }, [
                _vm._v(
                  " Solicitud de " +
                    _vm._s(
                      _vm.isDebtor
                        ? "Certificado de Liquidación"
                        : "Portabilidad Financiera"
                    ) +
                    " "
                ),
              ]),
              _vm.isDebtor
                ? _c(
                    "section",
                    {
                      staticClass:
                        "message-cliente-portability has-text-centered",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-body-client py-4 mx-2 px-2" },
                        [
                          _c("p", { staticClass: "legal-advisor-docs my-3" }, [
                            _vm._v(
                              " ¿Quieres tu certificado para iniciar un procedimiento de Portabilidad Financiera? "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "buttons is-centered" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "is-button-secondary px-5",
                                  class: {
                                    active: _vm.isFinancialPortability === true,
                                  },
                                  attrs: {
                                    id: "yesPortabilityButton",
                                    size: "is-medium",
                                    active: _vm.isFinancialPortability === true,
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setStatusPortability(true)
                                    },
                                  },
                                },
                                [_vm._v(" Sí ")]
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "is-button-secondary px-5",
                                  class: {
                                    active:
                                      _vm.isFinancialPortability === false,
                                  },
                                  attrs: {
                                    id: "noPortabilityButton",
                                    size: "is-medium",
                                    active:
                                      _vm.isFinancialPortability === false,
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setStatusPortability(false)
                                    },
                                  },
                                },
                                [_vm._v(" No ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              !_vm.isDebtor
                ? _c("section", { staticClass: "message" }, [_vm._m(0)])
                : _vm._e(),
              _c("ValidationObserver", {
                ref: "form",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ valid, errors }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.onSubmit.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._l(_vm.formData, function (section, i) {
                              return _c(
                                "section",
                                {
                                  key: i,
                                  staticClass: "transition-slow",
                                  class: { "hide-section": !section.isVisible },
                                },
                                [
                                  _c("h4", [_vm._v(_vm._s(section.title))]),
                                  _c(
                                    "transition-group",
                                    {
                                      staticClass: "columns is-multiline",
                                      attrs: {
                                        name: "fields-transition",
                                        tag: "div",
                                      },
                                    },
                                    _vm._l(section.fields, function (field, j) {
                                      return _c(
                                        "div",
                                        {
                                          key: `field-${j}`,
                                          staticClass: "column",
                                          class: {
                                            "is-full-mobile is-full-tablet is-half-desktopis-one-third-widescreen is-two-quarter-fullhd":
                                              field.type === "clearfix",
                                            "is-half-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd":
                                              field.type !== "clearfix" &&
                                              field.type !== "file",
                                          },
                                        },
                                        [
                                          field.type !== "clearfix"
                                            ? _c("ValidationProvider", {
                                                attrs: {
                                                  name: field.id,
                                                  rules: field.rules,
                                                  slim: "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        valid,
                                                        errors,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field",
                                                            },
                                                            [
                                                              field.label
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "label",
                                                                      class: {
                                                                        "is-focused":
                                                                          _vm.currentFocusField ===
                                                                            field.id ||
                                                                          _vm
                                                                            .formData[
                                                                            i
                                                                          ]
                                                                            .fields[
                                                                            j
                                                                          ]
                                                                            .value ||
                                                                          !field.hasAnimatedLabel,
                                                                      },
                                                                      attrs: {
                                                                        for: field.id,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            field.label
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "control",
                                                                },
                                                                [
                                                                  field.type ===
                                                                  "text"
                                                                    ? _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model.trim",
                                                                                value:
                                                                                  _vm
                                                                                    .formData[
                                                                                    i
                                                                                  ]
                                                                                    .fields[
                                                                                    j
                                                                                  ]
                                                                                    .value,
                                                                                expression:
                                                                                  "formData[i].fields[j].value",
                                                                                modifiers:
                                                                                  {
                                                                                    trim: true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "input is-rounded",
                                                                          class:
                                                                            {
                                                                              "": errors[0],
                                                                              "": valid,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              id: field.id,
                                                                              oninput:
                                                                                field.oninput,
                                                                              name: field.id,
                                                                              type: field.type,
                                                                              placeholder:
                                                                                _vm.currentFocusField !==
                                                                                field.id
                                                                                  ? field.label
                                                                                  : "",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .value,
                                                                            },
                                                                          on: {
                                                                            focus:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.currentFocusField =
                                                                                  field.id
                                                                              },
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .formData[
                                                                                    i
                                                                                  ]
                                                                                    .fields[
                                                                                    j
                                                                                  ],
                                                                                  "value",
                                                                                  $event.target.value.trim()
                                                                                )
                                                                              },
                                                                            blur: function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$forceUpdate()
                                                                            },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "static"
                                                                    ? _c(
                                                                        "span",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .value
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "products"
                                                                    ? _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model.number",
                                                                                value:
                                                                                  _vm
                                                                                    .formData[
                                                                                    i
                                                                                  ]
                                                                                    .fields[
                                                                                    j
                                                                                  ]
                                                                                    .value,
                                                                                expression:
                                                                                  "formData[i].fields[j].value",
                                                                                modifiers:
                                                                                  {
                                                                                    number: true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "input is-rounded",
                                                                          class:
                                                                            {
                                                                              "": errors[0],
                                                                              "": valid,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              id: field.id,
                                                                              name: field.id,
                                                                              type: "number",
                                                                              placeholder:
                                                                                _vm.currentFocusField !==
                                                                                field.id
                                                                                  ? field.label
                                                                                  : "",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .value,
                                                                            },
                                                                          on: {
                                                                            focus:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.currentFocusField =
                                                                                  field.id
                                                                              },
                                                                            input:
                                                                              [
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  )
                                                                                    return
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .formData[
                                                                                      i
                                                                                    ]
                                                                                      .fields[
                                                                                      j
                                                                                    ],
                                                                                    "value",
                                                                                    _vm._n(
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  )
                                                                                },
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return field.onChange(
                                                                                    $event
                                                                                      .target
                                                                                      .value,
                                                                                    i
                                                                                  )
                                                                                },
                                                                              ],
                                                                            blur: function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$forceUpdate()
                                                                            },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "select"
                                                                    ? _c(
                                                                        "b-select",
                                                                        {
                                                                          class:
                                                                            {
                                                                              "": errors[0],
                                                                              "": valid,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              id: field.id,
                                                                              name: field.id,
                                                                              rounded:
                                                                                "",
                                                                              size: "is-small",
                                                                              type: field.type,
                                                                            },
                                                                          on: {
                                                                            focus:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.currentFocusField =
                                                                                  field.id
                                                                              },
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                ;[
                                                                                  field.onChange(
                                                                                    $event,
                                                                                    i,
                                                                                    j
                                                                                  ),
                                                                                ]
                                                                              },
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .value,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .formData[
                                                                                      i
                                                                                    ]
                                                                                      .fields[
                                                                                      j
                                                                                    ],
                                                                                    "value",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "formData[i].fields[j].value",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "option",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  value:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  field.label
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._l(
                                                                            field.options,
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "option",
                                                                                {
                                                                                  key: item,
                                                                                  domProps:
                                                                                    {
                                                                                      value:
                                                                                        item,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        item
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                        ],
                                                                        2
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "radio"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._l(
                                                                            field.options,
                                                                            function (
                                                                              option
                                                                            ) {
                                                                              return _c(
                                                                                "button",
                                                                                {
                                                                                  key: option.value,
                                                                                  staticClass:
                                                                                    "button is-rounded is-button-secondary is-radio-button",
                                                                                  class:
                                                                                    {
                                                                                      active:
                                                                                        _vm
                                                                                          .formData[
                                                                                          i
                                                                                        ]
                                                                                          .fields[
                                                                                          j
                                                                                        ]
                                                                                          .value ===
                                                                                        option.value,
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      id: `${field.id}-${option.value}`,
                                                                                      type: "button",
                                                                                      value:
                                                                                        option,
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return field.onClick(
                                                                                          option.value,
                                                                                          i,
                                                                                          j
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        option.text
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .formData[
                                                                                        i
                                                                                      ]
                                                                                        .fields[
                                                                                        j
                                                                                      ]
                                                                                        .value,
                                                                                    expression:
                                                                                      "formData[i].fields[j].value",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  id: field.id,
                                                                                  type: "hidden",
                                                                                  name: field.id,
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .formData[
                                                                                      i
                                                                                    ]
                                                                                      .fields[
                                                                                      j
                                                                                    ]
                                                                                      .value,
                                                                                },
                                                                              on: {
                                                                                input:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    )
                                                                                      return
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .formData[
                                                                                        i
                                                                                      ]
                                                                                        .fields[
                                                                                        j
                                                                                      ],
                                                                                      "value",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        2
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "requestedProduct"
                                                                    ? _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .formData[
                                                                                    i
                                                                                  ]
                                                                                    .fields[
                                                                                    j
                                                                                  ]
                                                                                    .value,
                                                                                expression:
                                                                                  "formData[i].fields[j].value",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "input is-rounded transition-slow",
                                                                          attrs:
                                                                            {
                                                                              id: field.id,
                                                                              placeholder:
                                                                                field.placeholder,
                                                                              name: field.index,
                                                                              type: "text",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .value,
                                                                            },
                                                                          on: {
                                                                            focus:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.currentFocusField =
                                                                                  field.id
                                                                              },
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .formData[
                                                                                    i
                                                                                  ]
                                                                                    .fields[
                                                                                    j
                                                                                  ],
                                                                                  "value",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "requestedProduct"
                                                                    ? _c(
                                                                        "b-select",
                                                                        {
                                                                          staticClass:
                                                                            "select-product",
                                                                          attrs:
                                                                            {
                                                                              id: `select-${field.id}`,
                                                                              placeholder:
                                                                                "Seleccione un producto",
                                                                              name: field.id,
                                                                              rounded:
                                                                                "",
                                                                              size: "is-small",
                                                                            },
                                                                          on: {
                                                                            focus:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.currentFocusField =
                                                                                  field.id
                                                                              },
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData[
                                                                                  i
                                                                                ]
                                                                                  .fields[
                                                                                  j
                                                                                ]
                                                                                  .typeOfCredit
                                                                                  .value,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .formData[
                                                                                      i
                                                                                    ]
                                                                                      .fields[
                                                                                      j
                                                                                    ]
                                                                                      .typeOfCredit,
                                                                                    "value",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "formData[i].fields[j].typeOfCredit.value",
                                                                            },
                                                                        },
                                                                        _vm._l(
                                                                          field
                                                                            .typeOfCredit
                                                                            .options,
                                                                          function (
                                                                            item
                                                                          ) {
                                                                            return _c(
                                                                              "option",
                                                                              {
                                                                                key: item,
                                                                                attrs:
                                                                                  {
                                                                                    id: item,
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    value:
                                                                                      item,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                  field.type ===
                                                                  "file"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "b-upload",
                                                                            {
                                                                              staticClass:
                                                                                "file-label",
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .formData[
                                                                                      i
                                                                                    ]
                                                                                      .fields[
                                                                                      j
                                                                                    ]
                                                                                      .value,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .formData[
                                                                                          i
                                                                                        ]
                                                                                          .fields[
                                                                                          j
                                                                                        ],
                                                                                        "value",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "formData[i].fields[j].value",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "button is-button-secondary is-rounded",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-icon",
                                                                                    {
                                                                                      staticClass:
                                                                                        "file-icon",
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "upload",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "file-label",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Carga Aquí"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm
                                                                                .formData[
                                                                                i
                                                                              ]
                                                                                .fields[
                                                                                j
                                                                              ]
                                                                                .value
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "file-name",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .formData[
                                                                                              i
                                                                                            ]
                                                                                              .fields[
                                                                                              j
                                                                                            ]
                                                                                              .value
                                                                                              .name
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              errors.length
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "help is-danger",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          field.error
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              )
                            }),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "has-text-centered" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "is-button-primary",
                                      class: { "": errors[0], "": valid },
                                      attrs: {
                                        id: "button-create-finantial-portability-request",
                                        size: "is-medium",
                                        rounded: "",
                                        disabled: !valid
                                          ? !_vm.buttonIsEnabled
                                          : _vm.buttonIsEnabled,
                                      },
                                      on: { click: _vm.onConfirm },
                                    },
                                    [_vm._v(" Confirmar ")]
                                  ),
                                  (!valid ||
                                    _vm.isFinancialPortability === null) &&
                                  _vm.submitMessage
                                    ? _c(
                                        "p",
                                        { staticClass: "help is-danger" },
                                        [
                                          _vm._v(
                                            " Por favor revisa que todos los campos estén completos. "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "message-body" }, [
      _c("p", { staticClass: "legal-advisor" }, [
        _vm._v(
          " Atendiendo la Ley Nº21.236 que regula la Portabilidad Financiera y su reglamento, se pone a disposición de las instituciones financieras este canal para gestionar sus solicitudes. "
        ),
      ]),
      _c("p", { staticClass: "legal-advisor" }, [
        _vm._v(" Si eres cliente y necesitas el Certificado de Liquidación, "),
        _c("a", { attrs: { href: "/financial-portability?sender=debtor" } }, [
          _vm._v("haz click aquí."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }